export default __webpack_public_path__ + "static/media/02.8178103f.webp";